/**
 * The centred page column: up to 1376px wide, with the side gutter. Renders a
 * `div`, or the element named in `as`; every other prop (ref, id, …) passes
 * through.
 */
export default function Container({ as: Tag = 'div', className = '', ...props }) {
  return (
    <Tag
      className={`mx-auto w-full max-w-page px-gutter ${className}`}
      {...props}
    />
  )
}
